"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiTableBodyOverrides = void 0;
var createMuiTableBodyOverrides = function (_a) {
    var palette = _a.palette, shape = _a.shape;
    return ({
        root: {
            backgroundColor: palette.background.overlays,
            borderRadius: shape.borderRadius,
        },
    });
};
exports.createMuiTableBodyOverrides = createMuiTableBodyOverrides;
//# sourceMappingURL=MuiTableBody.js.map